import { render, staticRenderFns } from "./orders-page-payments.vue?vue&type=template&id=9599beb2"
import script from "./orders-page-payments.vue?vue&type=script&lang=js"
export * from "./orders-page-payments.vue?vue&type=script&lang=js"
import style0 from "./orders-page-payments.vue?vue&type=style&index=0&id=9599beb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports